import React, { Component } from 'react';
import BsySelect from '../BsySelect';
import { BsyUtils } from '../../utils/Utils';

class BsyWebhookSsoPane extends Component {
    constructor(props) {
        super(props);
        this.state = {
            config: props.config,
        }
        this.sso_endpoint_val = React.createRef();
        this.sig_crt_val = React.createRef();
        this.issuer_val = React.createRef();
        this.slo_endpoint_val = React.createRef();
        this.custom_secret_val = React.createRef();
        this.custom_sso_endpoint_val = React.createRef();
        this.custom_issuer_val = React.createRef();
        this.custom_slo_endpoint_val = React.createRef();
    }
    switchSaml = () => {
        let config = { ...this.state.config };
        config.type = "saml";
        this.setState({ config });
    }
    switchCustom = () => {
        let config = { ...this.state.config };
        config.type = "custom";
        this.setState({ config });
    }
    get_sig_alg = (e) => {
        let config = { ...this.state.config };
        config.sig_alg = e;
        this.setState({ config });
    }

    get_custom_sig_alg = (e) => {
        let config = { ...this.state.config };
        config.custom_sig_alg = e;
        this.setState({ config });
    }

    onSave = () => {
        let type = this.state.config.type || this.state.config.ssoType;
        if (type === "saml") {
            let data = {
                type: type,
                sso_endpoint: this.sso_endpoint_val.current ? this.sso_endpoint_val.current.value : undefined,
                sig_crt: this.sig_crt_val.current ? this.sig_crt_val.current.value : undefined,
                sig_alg: this.state.config.sig_alg,
                issuer: this.issuer_val.current ? this.issuer_val.current.value : undefined,
                slo_endpoint: this.slo_endpoint_val.current ? this.slo_endpoint_val.current.value : undefined,
            };
            let flag = true;
            this.sso_endpoint_val.current.classList.remove('error');
            this.sig_crt_val.current.classList.remove('error');
            this.issuer_val.current.classList.remove('error');
            if (data.sso_endpoint === "") {
                this.sso_endpoint_val.current.classList.add('error');
                flag = false;
            }
            if (data.sig_crt === "") {
                this.sig_crt_val.current.classList.add('error');
                flag = false;
            }
            if (data.issuer === "") {
                this.issuer_val.current.classList.add('error');
                flag = false;
            }
            flag && this.props.onSave && this.props.onSave(data, this.props.pane)
        } else if (type === "custom") {
            let data = {
                type: type,
                custom_secret: this.custom_secret_val.current ? this.custom_secret_val.current.value : undefined,
                custom_sso_endpoint: this.custom_sso_endpoint_val.current ? this.custom_sso_endpoint_val.current.value : undefined,
                custom_sig_alg: this.state.config.custom_sig_alg,
                custom_issuer: this.custom_issuer_val.current ? this.custom_issuer_val.current.value : undefined,
                custom_slo_endpoint: this.custom_slo_endpoint_val.current ? this.custom_slo_endpoint_val.current.value : undefined,
            };
            let flag = true;
            this.custom_secret_val.current.classList.remove('error');
            this.custom_sso_endpoint_val.current.classList.remove('error');
            if (data.custom_secret === "") {
                this.custom_secret_val.current.classList.add('error');
                flag = false;
            }
            if (data.custom_sso_endpoint === "") {
                this.custom_sso_endpoint_val.current.classList.add('error');
                flag = false;
            }
            flag && this.props.onSave && this.props.onSave(data, this.props.pane)
        }
    }

    createCustomSecret = () => {
        let customSecret = BsyUtils.getRandomCode(24);
        this.custom_secret_val.current.value = customSecret;
    }
    render() {
        const { config } = this.state;
        let type = config.type || config.ssoType;
        let items = [
            {
                text: 'SHA-1',
                value: 'SHA-1'
            }, {
                text: 'SHA-256',
                value: 'SHA-256'
            }, {
                text: 'SHA-512',
                value: 'SHA-512'
            },
        ]
        let countItem1 = [
            {
                text: 'HS256',
                value: 'HS256'
            }, {
                text: 'HS384',
                value: 'HS384'
            }, {
                text: 'HS512',
                value: 'HS512'
            },
        ]
        return (
            <div className="BsyWebhookSsoPane">
                <div className="sso-pane">
                    <div className="sso-body">
                        <div className="pane-item">
                            <div className="item-label">
                                {React.language('sso.config.method.tip')}
                            </div>
                            <div className="item-cont">
                                <div className="switch-type">
                                    <div className={"type-radio " + (type === 'saml' ? 'select' : '')} onClick={this.switchSaml}>
                                        <i className="icon-blank"></i>
                                        <span>SAML 2.0</span>
                                    </div>
                                    <div className={"type-radio " + (type === 'custom' ? 'select' : '')} onClick={this.switchCustom}>
                                        <i className="icon-blank"></i>
                                        <span>{React.language('sso.custom.api')}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="pane-item line"></div>
                        {
                            type === 'saml' ? <div className="saml-sso" key={type}>
                                <div className="pane-item">
                                    <div className="item-title">{React.language('sso.config.saml.tip')}</div>
                                </div>
                                <div className="pane-item">
                                    <div className="item-cont">
                                        <div className="item-label">
                                            SAML 2.0 Endpoint (HTTP)
                                            <span>*</span>
                                        </div>
                                        <div className="itme-input">
                                            <input type="text" defaultValue={config.sso_endpoint} maxLength="256" ref={this.sso_endpoint_val} />
                                        </div>
                                    </div>
                                </div>
                                <div className="pane-item">
                                    <div className="item-cont">
                                        <div className="item-label">
                                            {React.language('sso.config.idp.title')}
                                            <span>*</span>
                                        </div>
                                        <div className="itme-input">
                                            <textarea defaultValue={config.sig_crt} ref={this.sig_crt_val} />
                                        </div>
                                    </div>
                                </div>
                                <div className="pane-item">
                                    <div className="item-cont">
                                        <div className="item-label">
                                            {React.language('sso.config.algo.title')}
                                            <span>*</span>
                                        </div>
                                        <div className="itme-combck">
                                            <BsySelect
                                                allowBlank={false}
                                                searchable={false}
                                                minWidth={260}
                                                onStopEdit={this.get_sig_alg}
                                                value={config.sig_alg || 'SHA-1'}
                                                items={items}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="pane-item">
                                    <div className="item-cont">
                                        <div className="item-label">
                                            Issuer URL
                                            <span>*</span>
                                        </div>
                                        <div className="itme-input">
                                            <input type="text" defaultValue={config.issuer} maxLength="256" ref={this.issuer_val} />
                                        </div>
                                    </div>
                                </div>
                                <div className="pane-item">
                                    <div className="item-cont">
                                        <div className="item-label">
                                            SLO Endpoint (HTTP)
                                        </div>
                                        <div className="itme-input">
                                            <input type="text" defaultValue={config.slo_endpoint} maxLength="256" ref={this.slo_endpoint_val} />
                                        </div>
                                        <div className="item-tip">{React.language('sso.config.slo.tip')}</div>
                                    </div>
                                </div>
                            </div>
                                :
                            <div className="custom-sso" key={type}>
                                <div className="pane-item">
                                    <div className="item-cont">
                                        <div className="item-label">
                                            {React.language('sso.config.signin.title')}
                                            <span>*</span>
                                        </div>
                                        <div className="itme-input">
                                            <input type="text" defaultValue={config.custom_sso_endpoint} maxLength="256" ref={this.custom_sso_endpoint_val} />
                                        </div>
                                    </div>
                                </div>
                                <div className="pane-item">
                                    <div className="item-cont">
                                        <div className="item-label">
                                            {React.language('sso.config.cert.title')}
                                            <span>*</span>
                                        </div>
                                        <div className="item-input-button">
                                            <div className="itme-input">
                                                <input type="text" defaultValue={config.custom_secret} maxLength="256" ref={this.custom_secret_val} />
                                            </div>
                                            <div className="item-button" onClick={this.createCustomSecret}>
                                                <span>{React.language('sso.config.secret.title')}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="pane-item">
                                    <div className="item-cont">
                                        <div className="item-label">
                                            {React.language('sso.config.certAlgo.title')}
                                            <span>*</span>
                                        </div>
                                        <div className="itme-combck">
                                            <BsySelect
                                                allowBlank={false}
                                                searchable={false}
                                                minWidth={260}
                                                onStopEdit={this.get_custom_sig_alg}
                                                value={config.custom_sig_alg || 'HS256'}
                                                items={countItem1}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="pane-item">
                                    <div className="item-cont">
                                        <div className="item-label">
                                            Issuer URL
                                        </div>
                                        <div className="itme-input">
                                            <input type="text" defaultValue={config.custom_issuer} maxLength="256" ref={this.custom_issuer_val} />
                                        </div>
                                    </div>
                                </div>
                                <div className="pane-item">
                                    <div className="item-cont">
                                        <div className="item-label">
                                            {React.language('sso.config.signout.title')}
                                        </div>
                                        <div className="itme-input">
                                            <input type="text" defaultValue={config.custom_slo_endpoint} maxLength="256" ref={this.custom_slo_endpoint_val} />
                                        </div>
                                        <div className="item-tip">{React.language('sso.config.signout.tip')}</div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="sso-footer">
                        <div className="save-btn" onClick={this.onSave}>
                            <span>{React.language('save')}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BsyWebhookSsoPane;
